export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-7-d4aef791686ab1779a27a9f3c784bafd.jpg";